'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Actions = require('../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _CardStore = require('./CardStore');

var _CardStore2 = _interopRequireDefault(_CardStore);

var _CouponStore = require('./CouponStore');

var _CouponStore2 = _interopRequireDefault(_CouponStore);

var _MainStore = require('./MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _TipStore = require('./TipStore');

var _TipStore2 = _interopRequireDefault(_TipStore);

var _ScheduleScreenStore = require('./ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _CustomChargeStore = require('./CustomChargeStore');

var _CustomChargeStore2 = _interopRequireDefault(_CustomChargeStore);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Utility = require('../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_DELIVERY_TIP_PERCENTAGE = 20;
var DEFAULT_DINE_IN_PERCENTAGE = 15;
var DEFAULT_PICKUP_PERCENTAGE = 0;

var DELIVERY = "Delivery";
var PICKUP = "PickUp";
var CURBSIDEPICKUP = "CurbsidePickUp";
var DINEIN = "DineIn";

var CartStore = _reflux2.default.createStore({
    listenables: [_Actions2.default],
    init: function init() {
        this._cart = [];
        this._actualItems = {};
        // this._cartVisible = false;
        this._paymentMethod = {};
        this._deliveryAddress = {};
        this._orderType = PICKUP;
        this._orderInstruction = '';
        this._locationDetail = {};
        this._businessDetail = {};
        this._couponCode = null;
        this._percentOff = null;
        this._amountOff = null;
        this._deliveryFee = null;
        this._tip = 0;
        this._tipType = null;
        this._tipPercent = null;
        this._deliveryDistance = null;
        this._deliveryDistanceInMeter = null;
        this._deliveryFeeType = null;
        this._vMakeModel = '';
        this._vColor = '';
        this._isPreferCurbsideEnabled = false;
        this._isPickUpLocationSelected = false;
        this._isUtensilsAndNapkinsEnabled = '';
        // this._orderPaymentMethodObject = {};
        this._serviceLocationData = '';
        this._itemTaxError = false;
        this._roundOffStatus = false;
        this._roundOffValue = 0;
        this._fixedChargeValue = 0;
        this._defaultOptionalCharge = [];
        this._defaultOptionalFlag = true;
        this._customCharge = [];
        this._guestUserObject = {
            name: "",
            email: "",
            phoneNumber: "",
            password: "",
            createGuestUserAccount: false
        };
        this._cartOrderDetailsObj = {};

        this.listenTo(_MainStore2.default, this.onMainData);
        this.listenTo(_CardStore2.default, this.onPayment);
        // this.listenTo(AddressStore, this.onAddress);
        this.listenTo(_CouponStore2.default, this.onCoupon);
        this.listenTo(_TipStore2.default, this.onTip);
        this.listenTo(_ScheduleScreenStore2.default, this.onScheduleScreen);
        // this.listenTo(CustomChargeStore, this.onCustomCharge);
    },

    // get locationDetailPointer object
    onMainData: function onMainData(event, _data) {
        if (_data) {

            this._locationDetail = _data.LocationDetail;
            this._businessDetail = _data.BusinessDetail;

            // update the custom charge data store
            _Actions2.default.onMainDataCustom(_data);
            var orderType = this.getDefaultOrderType();
            this._orderType = orderType;
        }
    },
    getDefaultOrderType: function getDefaultOrderType() {

        var activeLocation = this._locationDetail;

        if (activeLocation != null) {
            var locationConfig = activeLocation.locationConfig;

            if (!Utils.isEmptyObj(locationConfig)) {
                if (locationConfig.hasOwnProperty("dineInOnly") && locationConfig.dineInOnly == true) {
                    return DINEIN;
                } else if (locationConfig.hasOwnProperty("defaultOrderType")) {
                    var defaultOrderType = locationConfig.defaultOrderType;
                    return defaultOrderType;
                } else {
                    // Default order type
                    return PICKUP;
                }
            } else {
                // Default order type
                return PICKUP;
            }
        } else {
            // Default order type
            return PICKUP;
        }
    },


    // Add payment method
    onPayment: function onPayment(event, _paymentMethod) {
        this._paymentMethod = _paymentMethod;
    },


    // Add delivery address
    onAddress: function onAddress(event, addressObject) {
        this._deliveryAddress = addressObject.deliveryAddress;
        this._orderType = addressObject.orderType;

        this.updateRoundOffStatusValue();
    },
    resetTip: function resetTip(orderType) {

        var tipPercentage = 0;
        var subTotal = this.getCartSubTotalWithDiscountAbs();

        if (orderType == "DineIn") {
            tipPercentage = DEFAULT_DINE_IN_PERCENTAGE;
            this._tipType = "percent";
        } else if (orderType == "PickUp") {
            tipPercentage = DEFAULT_PICKUP_PERCENTAGE;
            this._tipType = "notip";
        } else {
            tipPercentage = DEFAULT_DELIVERY_TIP_PERCENTAGE;
            this._tipType = "percent";
        }

        this._tipPercent = tipPercentage;
        var tipAmount = _lodash2.default.round(subTotal * this._tipPercent / 100, 2);
        this._tip = tipAmount;
        _Actions2.default.addTip(tipAmount, this._tipType, tipPercentage);
    },
    onScheduleScreen: function onScheduleScreen(event, scheduleObject) {

        if (scheduleObject.orderType != this._orderType) {
            this.resetTip(scheduleObject.orderType);

            // reset the custom charges but do not need to reload the cart
            this.resetCustomChargeDataOfCart(false);
        }

        this._orderType = scheduleObject.orderType;
        this._vColor = scheduleObject.vColor;
        this._vMakeModel = scheduleObject.vMakeModel;
        this._isPreferCurbsideEnabled = scheduleObject.isPreferCurbside;
        this._isPickUpLocationSelected = scheduleObject.isPickUpLocationSelected;

        this._deliveryAddress = scheduleObject.deliveryAddress;

        var deliveryAddress = scheduleObject.deliveryAddress;
        var currentUser = _parse2.default.User.current();
        var guestUserObject = this._guestUserObject;
        var orderType = this._orderType;

        //in case of guest user only
        //guestUserObj will be updated
        if (orderType === DELIVERY && Utils.isEmptyObj(currentUser) && !Utils.isEmptyObj(deliveryAddress)) {
            guestUserObject.name = deliveryAddress.name;
            guestUserObject.phoneNumber = Utils.formatPhoneNumber(deliveryAddress.phoneNumber);
        }

        this._serviceLocationData = scheduleObject.sldata;

        // Updated the delivery address details
        this.setDeliveryDistance(scheduleObject.deliveryDistance);
        this.setDeliveryDistanceInMeter(scheduleObject.deliveryDistanceInMeter);
        this.setDeliveryFeeType(scheduleObject.deliveryFeeType);

        // Load the updated value
        this.triggerCartChange();
    },


    //set user Details
    setGuestUserObject: function setGuestUserObject(userObj) {
        this._guestUserObject = userObj;

        var deliveryAddress = this._deliveryAddress;
        if (!Utils.isEmptyObj(deliveryAddress) && !Utils.isEmptyObj(userObj)) {
            deliveryAddress.name = userObj.name;

            if (userObj.hasOwnProperty("phoneNumber") && !Utils.isEmpty(userObj.phoneNumber)) {
                deliveryAddress.phoneNumber = Utils.removeNonNumber(userObj.phoneNumber);
            }
        }
        // Load the updated value
        this.triggerCartChange();
    },
    setCartOrderDetailsObj: function setCartOrderDetailsObj(order) {
        this._cartOrderDetailsObj = order;
    },
    getCartOrderDetailsObj: function getCartOrderDetailsObj() {
        return this._cartOrderDetailsObj;
    },
    resetCartOrderDetailsObj: function resetCartOrderDetailsObj() {
        this._cartOrderDetailsObj = {};
    },


    //return user Info Details in cartScreen.
    getGuestUserObject: function getGuestUserObject() {
        return this._guestUserObject;
    },


    // Add coupon details
    onCoupon: function onCoupon(event, couponObject) {
        this._percentOff = couponObject.percentOff;
        this._amountOff = couponObject.amountOff;
        this._couponCode = couponObject.couponCode;

        // Reset the custom charges after applied the coupon code
        this.resetCustomChargeDataOfCart(true);
    },


    // isPaymentMethodObjectAvailable(){
    //     if (Utils.isEmptyObj(this._orderPaymentMethodObject)){
    //         return false
    //     }
    //     else {
    //         return true
    //     }
    // },

    // Add tip details
    onTip: function onTip(event, tipObject) {

        this._tip = tipObject.tip;
        this._tipType = tipObject.tipType;
        this._tipPercent = tipObject.tipPercent;

        this.updateRoundOffStatusValue();
    },
    autoUpdateCustomChargeAfterItemDelete: function autoUpdateCustomChargeAfterItemDelete() {

        // get local optional charge state
        var defaultCharge = this.getDefaultOptionalCharge();

        // get custom charges
        var customCharges = this.getCustomCharge();

        if (defaultCharge.length > 0) {

            // discounted subtotal
            var totalValue = this.getCartSubTotalWithDiscountRounded();

            defaultCharge.forEach(function (charge, index, array) {

                var optionalCalculatedFee = _CustomChargeStore2.default.getCalculateFeeOfCharge(charge.valueObj, totalValue);

                defaultCharge[index].fee = optionalCalculatedFee;

                // find the charge based on the chargeId
                var chargeObjIndex = customCharges.findIndex(function (ch) {
                    return ch.chargeId == charge.chargeId;
                });
                customCharges[chargeObjIndex].fee = optionalCalculatedFee;
            });
        }

        // update the round off value after change the options
        this.updateRoundOffStatusValue();
    },
    updateDefaultOptionalCharge: function updateDefaultOptionalCharge(chargeObjIdx, selectedIdx, status, chargeTypeDetailsValue, chargeObject) {

        // get local optional charge state
        var defaultCharge = this.getDefaultOptionalCharge();

        // discounted subtotal
        var totalValue = this.getCartSubTotalWithDiscountRounded();

        // Option Name
        var optionName = chargeTypeDetailsValue.name;

        if (defaultCharge.length > 0) {

            var chargeObjIndex = defaultCharge.findIndex(function (charge) {
                return charge.chargeObjIdx == chargeObjIdx;
            });

            if (status) {

                var optionalCalculatedFee = _CustomChargeStore2.default.getCalculateFeeOfCharge(chargeTypeDetailsValue, totalValue);

                if (chargeObjIndex == -1) {

                    var obj = {
                        chargeObjIdx: chargeObjIdx,
                        defaultIdx: selectedIdx,
                        fee: optionalCalculatedFee,
                        custom: false,
                        label: chargeObject.name,
                        chargeId: chargeObject.chargeId,
                        valueObj: chargeTypeDetailsValue
                    };

                    // push the new object in the optional charge
                    this._defaultOptionalCharge.push(obj);
                } else {

                    defaultCharge[chargeObjIndex].defaultIdx = selectedIdx;
                    defaultCharge[chargeObjIndex].fee = optionalCalculatedFee;
                    defaultCharge[chargeObjIndex].custom = false;
                    defaultCharge[chargeObjIndex].label = chargeObject.name;
                    defaultCharge[chargeObjIndex].chargeId = chargeObject.chargeId;
                    defaultCharge[chargeObjIndex].valueObj = chargeTypeDetailsValue;
                    this._defaultOptionalCharge = defaultCharge;
                }
                // set the custom charge object with fee
                this.updateCustomChargeObjectWithFee(chargeObject, optionalCalculatedFee, selectedIdx, false, optionName);
            } else {

                // remove from the array

                if (chargeObjIndex != -1) {

                    // remove the element
                    defaultCharge.splice(chargeObjIndex, 1);

                    this._defaultOptionalCharge = defaultCharge;
                }

                // delete the custom charge object
                this.deleteCustomChargeObjectWithFee(chargeObject);
            }
        } else {
            var _optionalCalculatedFee = _CustomChargeStore2.default.getCalculateFeeOfCharge(chargeTypeDetailsValue, totalValue);

            if (status) {
                var _obj = {
                    chargeObjIdx: chargeObjIdx,
                    defaultIdx: selectedIdx,
                    fee: _optionalCalculatedFee,
                    custom: false,
                    label: chargeObject.name,
                    chargeId: chargeObject.chargeId,
                    valueObj: chargeTypeDetailsValue

                };

                this._defaultOptionalCharge = [_obj];

                // set the custom charge object with fee
                this.updateCustomChargeObjectWithFee(chargeObject, _optionalCalculatedFee, selectedIdx, false, optionName);
            } else {
                // delete the custom charge object
                this.deleteCustomChargeObjectWithFee(chargeObject);
            }
        }

        this.triggerCartChange();
    },


    // custom function not used now
    // Now we are not supporting the custom button functionality
    updateDefaultOptionalChargeCustom: function updateDefaultOptionalChargeCustom(chargeObjIdx, status, chargeObject) {

        var defaultCharge = this.getDefaultOptionalCharge();

        var defaultFee = 0;

        if (defaultCharge.length > 0) {

            var chargeObjIndex = defaultCharge.findIndex(function (charge) {
                return charge.chargeObjIdx == chargeObjIdx;
            });

            if (status) {

                if (chargeObjIndex == -1) {

                    var obj = {
                        chargeObjIdx: chargeObjIdx,
                        defaultIdx: null,
                        fee: defaultFee,
                        custom: true,
                        label: chargeObject.name,
                        customTextFieldVisible: true
                    };

                    this._defaultOptionalCharge.push(obj);
                } else {

                    defaultCharge[chargeObjIndex].defaultIdx = null;
                    defaultCharge[chargeObjIndex].fee = defaultFee;
                    defaultCharge[chargeObjIndex].custom = true;
                    defaultCharge[chargeObjIndex].label = chargeObject.name;
                    defaultCharge[chargeObjIndex].customTextFieldVisible = true;

                    this._defaultOptionalCharge = defaultCharge;
                }
                // set the custom charge object with fee
                this.updateCustomChargeObjectWithFee(chargeObject, defaultFee, null, true);
            } else {
                // remove from the array

                if (chargeObjIndex != -1) {

                    // remove the element
                    defaultCharge.splice(chargeObjIndex, 1);

                    this._defaultOptionalCharge = defaultCharge;
                }

                // delete the custom charge object
                this.deleteCustomChargeObjectWithFee(chargeObject);
            }
        } else {

            if (status) {
                var _obj2 = {
                    chargeObjIdx: chargeObjIdx,
                    defaultIdx: null,
                    fee: defaultFee,
                    custom: true,
                    label: chargeObject.name,
                    customTextFieldVisible: true
                };

                this._defaultOptionalCharge = [_obj2];

                // set the custom charge object with fee
                this.updateCustomChargeObjectWithFee(chargeObject, defaultFee, null, false);
            } else {

                // delete the custom charge object
                this.deleteCustomChargeObjectWithFee(chargeObject);
            }
        }

        this.triggerCartChange();
    },


    // custom function not used now
    // Now we are not supporting the custom button functionality
    updateCustomFieldValue: function updateCustomFieldValue(chargeObjIdx, chargeObject, customFieldIdValue) {

        var defaultCharge = this.getDefaultOptionalCharge();

        if (defaultCharge.length > 0) {

            var chargeObjIndex = defaultCharge.findIndex(function (charge) {
                return charge.chargeObjIdx == chargeObjIdx;
            });

            if (chargeObjIndex == -1) {

                var obj = {
                    chargeObjIdx: chargeObjIdx,
                    defaultIdx: null,
                    fee: customFieldIdValue,
                    custom: true,
                    label: chargeObject.name,
                    customTextFieldVisible: false
                };

                this._defaultOptionalCharge.push(obj);
            } else {

                defaultCharge[chargeObjIndex].defaultIdx = null;
                defaultCharge[chargeObjIndex].fee = customFieldIdValue;
                defaultCharge[chargeObjIndex].custom = true;
                defaultCharge[chargeObjIndex].label = chargeObject.name;
                defaultCharge[chargeObjIndex].customTextFieldVisible = false;
                this._defaultOptionalCharge = defaultCharge;
            }
            // set the custom charge object with fee
            this.updateCustomChargeObjectWithFee(chargeObject, customFieldIdValue, null, true);
        }

        this.triggerCartChange();
    },
    updateDefaultOptionalChargeValue: function updateDefaultOptionalChargeValue(optionalCharge) {
        var _this = this;

        if (this._defaultOptionalFlag == true) {

            if (optionalCharge && optionalCharge.length > 0) {

                // discounted subtotal
                var totalValue = this.getCartSubTotalWithDiscountRounded();

                var self = this;

                var defaultCharge = [];
                optionalCharge.map(function (charge, index) {

                    var typeDetailsObj = charge.typeDetails;

                    var defaultIndex = typeDetailsObj.defaultIdx;

                    // check the defaultIdx is defined or not
                    // checked the defaultIdx is not null
                    if (!Utils.isEmptyObj(typeDetailsObj) && typeDetailsObj.hasOwnProperty("defaultIdx") && defaultIndex != null) {

                        var _defaultIndex = charge.typeDetails.defaultIdx;

                        var chargeTypeValue = charge.typeDetails.values[_defaultIndex];

                        var optionName = chargeTypeValue.name;

                        var optionalCalculatedFee = _CustomChargeStore2.default.getCalculateFeeOfCharge(chargeTypeValue, totalValue);

                        var obj = {
                            chargeObjIdx: index,
                            defaultIdx: _defaultIndex,
                            fee: optionalCalculatedFee,
                            custom: false,
                            label: charge.name,
                            chargeId: charge.chargeId,
                            valueObj: chargeTypeValue
                        };

                        defaultCharge.push(obj);

                        // set optional default value in the cart object
                        // set the default charge object with fee
                        _this.updateCustomChargeObjectWithFee(charge, optionalCalculatedFee, _defaultIndex, false, optionName);
                    }
                });

                // Actions.updateFixedCustomChargeValue(roundTotal);
                this._defaultOptionalCharge = defaultCharge;
            } else {
                this._defaultOptionalCharge = [];
            }

            this._defaultOptionalFlag = false;

            // Load the updated value
            this.triggerCartChange();
        }
    },
    getDefaultOptionalCharge: function getDefaultOptionalCharge() {
        return this._defaultOptionalCharge;
    },


    // Add item to cart
    addItemToCart: function addItemToCart(itemId, itemInCart, actualItem) {

        var comparableItemInCart = _lodash2.default.omit(itemInCart, "itemQty");
        var inCartIndex = _lodash2.default.findIndex(this._cart, comparableItemInCart);
        if (inCartIndex === -1) {
            this._cart.push(itemInCart);
        } else {
            this._cart[inCartIndex].itemQty += itemInCart.itemQty;
        }
        if (!(itemId in this._actualItems)) {
            this._actualItems[itemId] = _lodash2.default.assign({}, this._actualItems[itemId], actualItem);
        }

        this.autoUpdateCustomChargeAfterItemDelete();
    },

    // Update item in cart
    updateItemInCart: function updateItemInCart(itemId, updatedItemInCart, priorItemInCart) {

        var inCartIndex = _lodash2.default.findIndex(this._cart, priorItemInCart);
        if (inCartIndex === -1) {
            this._cart.push(updatedItemInCart);
        } else {
            this._cart[inCartIndex] = updatedItemInCart;
        }

        // this.resetCustomChargeDataOfCart();
        this.autoUpdateCustomChargeAfterItemDelete();

        //change added by DA
        var cartOrderType = this.getOrderType();
        var orderType = cartOrderType ? cartOrderType : "Delivery";
        // check for curbside Pickup
        // check the ordertype is PickUp and Curbside PickUp option is selected
        if (orderType == PICKUP && this.getIsPreferCurbsideEnabled()) {
            orderType = CURBSIDEPICKUP;
        }

        this.loadDefaultFixedOptionalChargeValue(orderType);

        // this.triggerCartChange();
    },

    // Remove item from cart
    removeItemFromCart: function removeItemFromCart(inCartIndex) {
        var self = this;
        var removedItem = this._cart.splice(inCartIndex, 1);
        var idx = _lodash2.default.findIndex(this._cart, function (cartItem) {
            return self._cart.itemObjectId == removedItem.itemObjectId;
        });
        if (idx === -1) {
            delete this._actualItems[removedItem[0].itemObjectId];
        }

        if (this._cart.length === 0) {
            this._orderInstruction = '';
            // this.resetCustomChargeDataOfCart();
            this.clearCartStore();
            // Actions.resetDeliveryAddress();
            // Actions.clearScheduleScreenStore();
        } else {
            var cartOrderType = this.getOrderType();
            var orderType = cartOrderType ? cartOrderType : "Delivery";

            // check for curbside Pickup
            // check the ordertype is PickUp and Curbside PickUp option is selected
            if (orderType == PICKUP && this.getIsPreferCurbsideEnabled()) {
                orderType = CURBSIDEPICKUP;
            }

            this.loadDefaultFixedOptionalChargeValue(orderType);
            this.autoUpdateCustomChargeAfterItemDelete();
        }

        // this.resetCustomChargeDataOfCart();
    },


    // Add total order instruction
    addOrderInstructions: function addOrderInstructions(orderInstruction) {
        this._orderInstruction = orderInstruction;
    },

    // Get total order instruction
    getOrderInstructions: function getOrderInstructions() {
        return this._cart.length > 0 ? this._orderInstruction : '';
    },
    addIsUtensilsAndNapkinsEnabled: function addIsUtensilsAndNapkinsEnabled(isUtensilsAndNapkinsEnabled) {
        this._isUtensilsAndNapkinsEnabled = isUtensilsAndNapkinsEnabled;
    },

    // Get Dine In
    getDineInServiceLocationData: function getDineInServiceLocationData() {
        return this._serviceLocationData;
    },


    // Get total order instruction
    getOrderVehicleMakeModel: function getOrderVehicleMakeModel() {
        return this._vMakeModel;
    },

    // Get total order instruction
    getOrderVehicleColor: function getOrderVehicleColor() {
        return this._vColor;
    },

    // check curbside enabled or not
    getIsPreferCurbsideEnabled: function getIsPreferCurbsideEnabled() {
        return this._isPreferCurbsideEnabled;
    },
    getIsPickUpLocationSelected: function getIsPickUpLocationSelected() {
        return this._isPickUpLocationSelected;
    },


    // check Utensils and Napkins enabled or not
    getIsUtensilsAndNapkinsEnabled: function getIsUtensilsAndNapkinsEnabled() {
        return this._isUtensilsAndNapkinsEnabled;
    },


    //Trigger cart change
    triggerCartChange: function triggerCartChange() {
        this.trigger('change', this._cart);
    },

    // Get items in the cart
    getCartItems: function getCartItems() {
        return this._cart;
    },


    // Get items count in the cart
    getTotalCartCount: function getTotalCartCount() {
        var cart = this._cart;
        // console.log("this._cart: " + JSON.stringify(this._cart))
        return this._cart.length;
    },


    // Get items count in the cart
    getCartCount: function getCartCount() {
        var cart = this._cart;
        var totalCount = 0;
        if (cart.length > 0) {
            //Iterate over the objects in the array
            //destructured the itemQty and then added the total
            //itemQty
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = cart[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref2 = _step.value;
                    var itemQty = _ref2.itemQty;

                    totalCount += itemQty;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        return totalCount;
    },


    // Get location name of current location
    getLocationName: function getLocationName() {
        return this._locationDetail.name;
    },


    // Get tax info of given location
    getTaxInfo: function getTaxInfo() {
        if (this.getLocationDetail()) {
            var taxes = this.getLocationDetail().taxes;
            return taxes;
        } else {
            return 0;
        }
    },
    setItemTaxError: function setItemTaxError(errorStatus) {
        this._itemTaxError = errorStatus;
    },
    getItemTaxError: function getItemTaxError() {
        return this._itemTaxError;
    },


    // check the item tax is configured or not
    isItemTaxConfigured: function isItemTaxConfigured() {
        if (this._locationDetail.taxConfig) {
            return true;
        } else {
            return false;
        }
    },

    // get TaxConfig from locationDetail
    getItemTaxConfig: function getItemTaxConfig() {
        if (this._locationDetail.taxConfig) {
            return this._locationDetail.taxConfig;
        } else {
            return null;
        }
    },
    checkItemTaxIdExistInTaxConfig: function checkItemTaxIdExistInTaxConfig(itemTaxId) {

        var self = this;
        // Item tax config Rates
        var itemTaxConfig = self.getItemTaxConfig();

        // locationDetails.taxConfig.taxRates
        var taxRates = Utils.extractWebsiteConfig(itemTaxConfig, "taxRates");

        var filteredTaxObject = taxRates.filter(function (obj) {
            return obj.id == itemTaxId;
        }).map(function (obj) {
            return obj;
        });

        if (filteredTaxObject.length > 0) {
            return true;
        } else {
            return false;
        }
    },
    getOnlineOrderingHours: function getOnlineOrderingHours() {
        var orderType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


        switch (orderType) {
            case 'PickUp':
                // code block
                return this._locationDetail.pickUpHours ? this._locationDetail.pickUpHours : this._locationDetail.openHours;
                // return "pickup";
                break;
            case 'Delivery':
                // code block
                return this._locationDetail.deliveryHours ? this._locationDetail.deliveryHours : this._locationDetail.openHours;
                // return "delivery";
                break;
            default:
                // code block
                return this._locationDetail.openHours;
            // return 'open';
        }
    },
    getTipType: function getTipType() {
        return this._tipType;
    },
    getTipPercent: function getTipPercent() {
        return this._tipPercent;
    },
    calculateNewTip: function calculateNewTip() {
        var subTotal = this.getCartSubTotalWithDiscountAbs();

        if (this._tipType == "percent") {
            return _lodash2.default.round(subTotal * this._tipPercent / 100, 2);
        } else if (this._tipType == "custom") {
            return this._tip;
        } else if (this._tipType == "notip") {
            return this._tip;
        } else {
            var tipAmount = _lodash2.default.round(subTotal * 15 / 100, 2);
            return tipAmount;
        }
    },
    getTip: function getTip() {
        var subTotal = this.getCartSubTotalWithDiscountAbs();

        if (this._tipType == "percent") {
            return _lodash2.default.round(subTotal * this._tipPercent / 100, 2);
        } else if (this._tipType == "custom") {
            return this._tip;
        } else if (this._tipType == "notip") {
            this._tipPercent = null;
            this._tip = 0;
            return this._tip;
        } else {

            var tipPercentage = 0;
            var currentOrderType = this.getOrderType();

            if (currentOrderType == "DineIn") {
                tipPercentage = DEFAULT_DINE_IN_PERCENTAGE;
                this._tipType = "percent";
            } else if (currentOrderType == "PickUp") {
                tipPercentage = DEFAULT_PICKUP_PERCENTAGE;
                this._tipType = "notip";
            } else {
                tipPercentage = DEFAULT_DELIVERY_TIP_PERCENTAGE;
                this._tipType = "percent";
            }

            this._tipPercent = tipPercentage;
            var tipAmount = _lodash2.default.round(subTotal * this._tipPercent / 100, 2);
            this._tip = tipAmount;
            _Actions2.default.addTip(tipAmount, this._tipType, tipPercentage);
            return tipAmount;
        }
    },


    // Get minimum amount of order for given location
    getMinimumAmountOrder: function getMinimumAmountOrder() {
        if (this.getDeliveryInfo()) {
            return this.getDeliveryInfo().minAmount;
        } else if (this._locationDetail && this._locationDetail.deliveryConfig) {
            return this._locationDetail.deliveryConfig.minAmount;
        } else {
            return 0;
        }
    },


    // Get delivery fee of given location
    getDeliveryFeeAbs: function getDeliveryFeeAbs() {
        if (this.getOrderType() == 'PickUp') {
            return 0;
        } else if (this.getOrderType() == 'Delivery' && this.getDeliveryConfigInfo() != null && !Utils.isEmptyObj(this.getDeliveryAddress())) {

            var deliveryFee = this.calculateDeliveryFee();

            if (deliveryFee != null) {
                return deliveryFee;
            } else {
                // Actions.resetDeliveryAddress();
                return 0;
            }
        } else {
            return 0;
        }
    },
    getDeliveryFeeRounded: function getDeliveryFeeRounded() {
        var digit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

        return _lodash2.default.round(this.getDeliveryFeeAbs(), digit).toFixed(digit);
    },


    // Get location id
    getLocationDetailId: function getLocationDetailId() {
        if (this._locationDetail) {
            return this._locationDetail.objectId;
        } else {
            return null;
        }
    },
    getLocationDetail: function getLocationDetail() {

        if (this._locationDetail) {
            return this._locationDetail;
        } else {
            return null;
        }
    },


    // get deliveryConfig if exist
    getDeliveryConfig: function getDeliveryConfig() {
        if (this._locationDetail.deliveryConfig) {
            return this._locationDetail.deliveryConfig;
        } else {
            return null;
        }
    },

    // get deliveryInfo if exist
    getDeliveryInfo: function getDeliveryInfo() {
        if (this._locationDetail.deliveryInfo) {
            return this._locationDetail.deliveryInfo;
        } else {
            return null;
        }
    },


    // get ServiceFee if exist
    isServiceFeeAvailable: function isServiceFeeAvailable() {

        if (this.getOrderType() == 'DineIn') {
            if (this._locationDetail.dineInServiceFee) {
                return this._locationDetail.dineInServiceFee;
            } else {
                return null;
            }
        } else {
            if (this._locationDetail.serviceFee) {
                return this._locationDetail.serviceFee;
            } else {
                return null;
            }
        }
    },


    // get CurbsidePickup if it is exist
    isLocationCurbsidePickupEnabled: function isLocationCurbsidePickupEnabled() {
        var isCurbsidePickup = false;
        if (this._locationDetail.curbsidePickup && this._locationDetail.curbsidePickup.enabled) {
            isCurbsidePickup = true;
        }
        return isCurbsidePickup;
    },


    // get CurbsidePickup if exist
    getCurbsidePickupInstructions: function getCurbsidePickupInstructions() {
        var instructions = null;
        if (this.isLocationCurbsidePickupEnabled()) {

            if (this._locationDetail.curbsidePickup && this._locationDetail.curbsidePickup.instructions) {
                var curbsideInstructions = this._locationDetail.curbsidePickup.instructions;
                instructions = curbsideInstructions;
            }
        }
        return instructions;
    },


    // // get DineIn if it is exist
    // isDineInEnabled() {
    //     let isDineIn = false;
    //     if (this._locationDetail.dineIn && this._locationDetail.dineIn.enabled) {
    //         isDineIn = true;
    //     }
    //
    //     return isDineIn;
    // },

    // get DineIn Instructions if exist
    getDineInInstructions: function getDineInInstructions() {
        var instructions = null;
        if (_MainStore2.default.isDineInEnabled()) {

            if (this._locationDetail.dineIn && this._locationDetail.dineIn.instructions) {
                var dineInInstructions = this._locationDetail.dineIn.instructions;
                instructions = dineInInstructions;
            }
        }
        return instructions;
    },


    // get CurbsidePickup if exist
    getDineInServiceLocation: function getDineInServiceLocation() {

        if (_MainStore2.default.isDineInEnabled()) {

            /* Get all the query parameters using window.location.search */
            var search = window.location.search;
            var params = new URLSearchParams(search);

            /* sl is the Service Location parameter which return the title value */
            var serviceLocation = params.get('sl');

            if (serviceLocation != null) {

                return serviceLocation;
            } else if (this._locationDetail.dineIn.serviceLocation && this._locationDetail.dineIn.serviceLocation != null) {
                return this._locationDetail.dineIn.serviceLocation;
            } else {
                return "Table Number";
            }
        } else {
            return null;
        }
    },


    // is dine in phone
    isDineInPhoneRequired: function isDineInPhoneRequired() {
        var askPhone = true;
        if (_MainStore2.default.isDineInEnabled()) {
            return this._locationDetail.dineIn.askPhone;
        }
        return askPhone;
    },


    // get deliveryInfo if exist
    getDeliveryConfigInfo: function getDeliveryConfigInfo() {
        if (this._locationDetail.deliveryInfo) {
            return this._locationDetail.deliveryInfo;
        } else if (this._locationDetail.deliveryConfig) {
            return this._locationDetail.deliveryConfig;
        } else {
            return null;
        }
    },


    // check the delivery coordinates is set or not
    getDeliveryCoordinates: function getDeliveryCoordinates() {

        var deliveryDetails = this.getDeliveryConfigInfo();
        if (deliveryDetails != null) {
            var coordinates = Utils.extractWebsiteConfig(deliveryDetails, "coordinates");
            return coordinates ? coordinates : null;
        } else {
            return null;
        }
    },


    // is delivery fee taxable?
    isDeliveryFeeTaxable: function isDeliveryFeeTaxable() {

        var deliveryModal = this.getDeliveryConfigInfo();
        if (deliveryModal != null) {
            var taxDeliveryFee = deliveryModal.taxDeliveryFee;
            if (typeof taxDeliveryFee !== 'undefined') {
                // the variable is defined
                return taxDeliveryFee;
            } else {
                return true;
            }
        }
    },
    calculateDeliveryFee: function calculateDeliveryFee() {

        var distanceInMiles = this.getDeliveryDistance();
        var distanceInMeters = this.getDeliveryDistanceInMeter();

        // Do not need to convert the distance in meters
        // let distanceInMeters = Utils.convertMilesInMeters(distanceInMiles);

        // get the discounted total amount
        var orderTotalAmount = this.getCartSubTotalWithDiscountAbs();

        if (this.getDeliveryInfo() != null) {
            // get deliveryInfo object value

            var deliveryFee = this.getDeliveryFee(distanceInMeters, orderTotalAmount);

            this.setDeliveryFee(deliveryFee);
            return deliveryFee;
        } else if (this.getDeliveryConfig() != null) {

            var deliveryConfig = this.getDeliveryConfig();

            var deliveryFees = Utils.extractWebsiteConfig(deliveryConfig, "fee");

            var rangeMap = Utils.getDeliveryRange(deliveryFees);

            // call a function to calculate the delivery fee charges
            var _deliveryFee = this.getDeliveryConfigFee(distanceInMiles, rangeMap, orderTotalAmount);

            this.setDeliveryFee(_deliveryFee);

            return _deliveryFee;
        } else {
            return null;
        }
    },
    calculateGuestDeliveryFee: function calculateGuestDeliveryFee(distanceInMiles, distanceInMeters) {

        // let distanceInMiles = distanceInMiles;
        // let distanceInMeters = distanceInMeters;

        // Do not need to convert the distance in meters
        // let distanceInMeters = Utils.convertMilesInMeters(distanceInMiles);

        // get the discounted total amount
        var orderTotalAmount = this.getCartSubTotalWithDiscountAbs();

        if (this.getDeliveryInfo() != null) {
            // get deliveryInfo object value

            var deliveryFee = this.getDeliveryFee(distanceInMeters, orderTotalAmount);

            this.setDeliveryFee(deliveryFee);
            return deliveryFee;
        } else if (this.getDeliveryConfig() != null) {

            var deliveryConfig = this.getDeliveryConfig();

            var deliveryFees = Utils.extractWebsiteConfig(deliveryConfig, "fee");

            var rangeMap = Utils.getDeliveryRange(deliveryFees);

            // call a function to calculate the delivery fee charges
            var _deliveryFee2 = this.getDeliveryConfigFee(distanceInMiles, rangeMap, orderTotalAmount);

            this.setDeliveryFee(_deliveryFee2);

            return _deliveryFee2;
        } else {
            return null;
        }
    },
    getDeliveryConfigFee: function getDeliveryConfigFee(distanceInMiles, rangeMap, orderTotalAmount) {
        var range = Object.keys(rangeMap);
        var deliveryFee = 0;
        for (var i = 0; i < range.length; i++) {
            if (distanceInMiles <= range[i]) {
                deliveryFee = rangeMap[range[i]];
                break;
            }
        }

        if (this._locationDetail.deliveryConfig.feeType && this._locationDetail.deliveryConfig.feeType == 'fixed') {
            return deliveryFee;
        } else if (this._locationDetail.deliveryConfig.feeType && this._locationDetail.deliveryConfig.feeType == 'percentage') {

            var deliveryFeeValue = orderTotalAmount * deliveryFee / 100;

            return _lodash2.default.round(deliveryFeeValue, 2);
        } else {
            return deliveryFee;
        }
    },


    // get deliveryFee amount fee
    getDeliveryFee: function getDeliveryFee(distanceInMeters, orderPrice) {
        if (this.getDeliveryInfo()) {
            var deliveryInfo = this.getDeliveryInfo();

            // let minAmount = Utils.extractWebsiteConfig(deliveryInfo, "minAmount");
            var feeType = Utils.extractWebsiteConfig(deliveryInfo, "feeType");

            var feeMatrix = Utils.extractWebsiteConfig(deliveryInfo, "feeMatrix");

            if (feeMatrix.length > 0) {

                var deliveryFee = this.getDeliveryFeeConfigured(distanceInMeters, orderPrice);

                if (feeType == "fixed") {
                    return deliveryFee;
                }

                if (feeType == "percentage") {

                    var deliveryFeeValue = orderPrice * deliveryFee / 100;
                    return _lodash2.default.round(deliveryFeeValue, 2);
                }
            }
        }

        return null;
    },

    // find match range array
    getDeliveryFeeConfigured: function getDeliveryFeeConfigured(distanceInMeters, orderPrice) {
        if (this.getDeliveryInfo()) {
            var deliveryInfo = this.getDeliveryInfo();

            var feeMatrix = Utils.extractWebsiteConfig(deliveryInfo, "feeMatrix");

            if (feeMatrix.length > 0) {

                for (var i = 0; i < feeMatrix.length; i++) {
                    var deliveryRange = feeMatrix[i];

                    if (this.getContains(deliveryRange, distanceInMeters)) {
                        return this.getFee(deliveryRange, distanceInMeters, orderPrice);
                    }
                }
            }
        }

        return null;
    },

    // check the delivery range match or not
    getContains: function getContains(deliveryRange, distanceInMeters) {

        if (distanceInMeters >= deliveryRange.rangeStart && distanceInMeters <= deliveryRange.rangeEnd) {
            return true;
        }
        return false;
    },


    // Return delivery fee. "negative" value means delivery fee could not be calculated.
    getFee: function getFee(deliveryRange, distanceInMeters, price) {

        var feeArray = Utils.extractWebsiteConfig(deliveryRange, "feeArray");

        for (var i = 0; i < feeArray.length; i++) {
            var priceRangeFee = feeArray[i];
            if (this.getPriceRangeContains(priceRangeFee, price)) {
                return priceRangeFee.fee;
            }
        }
        return null;
    },

    // check the price match in order or not
    getPriceRangeContains: function getPriceRangeContains(priceRangeFee, price) {
        if (price >= priceRangeFee.priceStart && price <= priceRangeFee.priceEnd) {
            return true;
        }
        return false;
    },


    // get Max delivery distance in meters
    getMaxDeliveryDistanceInMeters: function getMaxDeliveryDistanceInMeters() {

        if (this.getDeliveryInfo()) {
            var deliveryInfo = this.getDeliveryInfo();

            var feeMatrix = Utils.extractWebsiteConfig(deliveryInfo, "feeMatrix");

            if (feeMatrix.length > 0) {
                return feeMatrix[feeMatrix.length - 1].rangeEnd;
            }
        }

        return null;
    },


    // Get business id
    getBusinessDetailId: function getBusinessDetailId() {
        if (this._businessDetail) {
            return this._businessDetail.objectId;
        } else {
            return null;
        }
    },
    getBusinessDetail: function getBusinessDetail() {
        if (this._businessDetail) {
            return this._businessDetail;
        } else {
            return null;
        }
    },
    getTaxedPriceAbs: function getTaxedPriceAbs() {
        var _this2 = this;

        var taxableAmount = this.getCartSubTotalWithDiscountAbs();

        var deliveryModal = this.getDeliveryConfigInfo();

        var locationTax = this.getTaxInfo();

        if (this.getOrderType() == 'Delivery' && deliveryModal != null && this.isDeliveryFeeTaxable()) {
            var deliveryFee = _lodash2.default.round(this.getDeliveryFeeAbs(), 2);
            taxableAmount = parseFloat(taxableAmount) + parseFloat(deliveryFee);
        }

        var customCharges = this.getCustomCharge();

        if (customCharges.length > 0) {

            customCharges.forEach(function (charge, index, array) {

                if (charge.taxable) {
                    var chargeFee = charge.fee;
                    taxableAmount = parseFloat(taxableAmount) + parseFloat(chargeFee);

                    // Update Taxes fee of charge
                    var chargeTax = chargeFee * locationTax / 100;
                    _this2._customCharge[index].tax = Utils.toRoundStr(chargeTax, 2);
                } else {
                    _this2._customCharge[index].tax = Utils.toRoundStr(0, 2);
                }
            });
        }

        return taxableAmount * locationTax / 100;
    },
    getTaxedPriceRounded: function getTaxedPriceRounded() {
        var digit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;


        if (this.isItemTaxConfigured()) {
            // Calculate the individual item tax
            return _lodash2.default.round(this.getItemTaxPriceRounded(), digit).toFixed(digit);
        } else {
            // default location tax for all the items
            return _lodash2.default.round(this.getTaxedPriceAbs(), digit).toFixed(digit);
        }
    },
    getItemTaxPriceRounded: function getItemTaxPriceRounded() {
        var _this3 = this;

        var self = this;

        // calculate item tax price
        var itemTaxPrice = self.calculateItemTaxPrice();

        // check delivery fee is taxable or not
        var deliveryModal = self.getDeliveryConfigInfo();
        var currentOrderType = self.getOrderType();
        var isDeliveryFeeTaxable = self.isDeliveryFeeTaxable();
        var locationTax = self.getTaxInfo();

        if (currentOrderType == 'Delivery' && deliveryModal != null && isDeliveryFeeTaxable) {
            var deliveryFeePrice = self.getDeliveryFeeAbs();
            var deliveryFeePriceRounded = _lodash2.default.round(deliveryFeePrice, 2);

            // calculate delivery fee percentage
            var deliveryFeeTax = deliveryFeePriceRounded * locationTax / 100;

            // add delivery tax in item tax
            itemTaxPrice = parseFloat(itemTaxPrice) + parseFloat(deliveryFeeTax);
        }

        var customCharges = this.getCustomCharge();

        if (customCharges.length > 0) {

            customCharges.forEach(function (charge, index, array) {

                if (charge.taxable) {
                    var chargeFee = charge.fee;
                    var chargeFeeTax = chargeFee * locationTax / 100;

                    // add tax in item tax
                    itemTaxPrice = parseFloat(itemTaxPrice) + parseFloat(chargeFeeTax);

                    _this3._customCharge[index].tax = Utils.toRoundStr(chargeFeeTax, 2);
                } else {
                    _this3._customCharge[index].tax = Utils.toRoundStr(0, 2);
                }
            });
        }

        return itemTaxPrice;
    },
    calculateItemTaxPrice: function calculateItemTaxPrice() {
        var _this4 = this;

        var self = this;

        // get cart item list
        var cartBuffer = self.getCartItems();

        var totalItemTax = 0;
        if (cartBuffer.length > 0) {
            // loop start
            cartBuffer.forEach(function (cartItem, idx, array) {

                // get the item details
                var actualItem = self.getActualItem(cartItem.itemObjectId);

                var itemTaxId = actualItem.itemTaxId;

                if (itemTaxId != null) {

                    // Item tax config Rates
                    var itemTaxConfig = self.getItemTaxConfig();

                    // locationDetails.taxConfig.taxRates
                    var taxRates = Utils.extractWebsiteConfig(itemTaxConfig, "taxRates");

                    var filteredTaxObject = taxRates.filter(function (obj) {
                        return obj.id == itemTaxId;
                    }).map(function (obj) {
                        return obj;
                    });

                    if (filteredTaxObject.length > 0) {

                        var itemTaxObject = filteredTaxObject[0];
                        var taxPercentage = itemTaxObject.rate;

                        var itemTaxValue = self.calculateTaxPercentage(cartItem, taxPercentage);

                        totalItemTax = parseFloat(totalItemTax) + parseFloat(itemTaxValue);
                    } else {

                        _this4.setItemTaxError(true);

                        // Global object of itemTaxError: false || set true
                        // if itemTaxId not exist in the locationDetail then return the null
                        // return 0;
                    }
                } else {
                    // get the location tax
                    var _taxPercentage = self.getTaxInfo();
                    var _itemTaxValue = self.calculateTaxPercentage(cartItem, _taxPercentage);

                    totalItemTax = parseFloat(totalItemTax) + parseFloat(_itemTaxValue);
                }
            });
        }
        return totalItemTax;
    },
    calculateTaxPercentage: function calculateTaxPercentage(Item, taxPercentage) {

        var totalItemPrice = Item.itemPrice * Item.itemQty;
        var totalItemPriceRounded = _lodash2.default.round(totalItemPrice, 2);

        var itemTaxValue = totalItemPriceRounded * taxPercentage / 100;

        return itemTaxValue;
    },
    getCartTotalWithoutTaxRounded: function getCartTotalWithoutTaxRounded() {
        var digit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

        var total = this._cart.reduce(function (prVal, currObj) {
            return prVal + currObj.itemPrice * currObj.itemQty;
        }, 0);
        return _lodash2.default.round(total, digit).toFixed(digit);
    },
    getCartTotalWithoutTaxAbs: function getCartTotalWithoutTaxAbs() {
        var total = this._cart.reduce(function (prVal, currObj) {
            return prVal + currObj.itemPrice * currObj.itemQty;
        }, 0);
        return total;
    },
    getCartSubTotalWithDiscountAbs: function getCartSubTotalWithDiscountAbs() {
        var total = this.getCartTotalWithoutTaxAbs();
        var discountedSubTotal = 0;

        discountedSubTotal = _lodash2.default.round(total, 2) - _lodash2.default.round(this.getDiscountAmountAbs(), 2);

        return discountedSubTotal;
    },
    getDiscountAmountAbs: function getDiscountAmountAbs() {
        var discountAmount = 0;
        var total = _lodash2.default.round(this.getCartTotalWithoutTaxAbs(), 2);

        if (this._percentOff) {
            discountAmount = total * this._percentOff / 100;
        } else if (this._amountOff) {
            discountAmount = this._amountOff;
        }

        return discountAmount;
    },
    getServiceFeeDesc: function getServiceFeeDesc() {
        if (this.isServiceFeeAvailable() != null) {
            var serviceFee = this.isServiceFeeAvailable();
            var description = serviceFee.desc;
            return description ? description : null;
        } else {
            return null;
        }
    },
    getServiceFeeRounded: function getServiceFeeRounded() {
        var digit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

        return _lodash2.default.round(this.getServiceFeeAbs(), digit).toFixed(digit);
    },
    getServiceFeeAbs: function getServiceFeeAbs() {

        var serviceFee = this.isServiceFeeAvailable();

        var serviceFeeObj = this.isServiceFeeAvailable();

        if (serviceFeeObj != null) {

            if (serviceFeeObj.hasOwnProperty("minAmount") && serviceFeeObj.minAmount != 0) {

                var minAmount = serviceFeeObj.minAmount;
                var subTotal = _lodash2.default.round(this.getCartSubTotalWithDiscountRounded(), 2);

                if (subTotal >= minAmount) {
                    return this.calculateServiceFee();
                } else {
                    return 0;
                }
            } else {
                return this.calculateServiceFee();
            }
        } else {
            return 0;
        }
    },
    calculateServiceFee: function calculateServiceFee() {
        var serviceFeeObj = this.isServiceFeeAvailable();

        if (!Utils.isEmptyObj(serviceFeeObj)) {
            var feeType = serviceFeeObj.feeType;
            var fee = serviceFeeObj.fee;

            if (feeType && feeType == "fixed") {
                return fee;
            }

            if (feeType && feeType == "percentage") {

                var subTotal = _lodash2.default.round(this.getCartSubTotalWithDiscountRounded(), 2);

                var serviceFeeValue = subTotal * fee / 100;

                return _lodash2.default.round(serviceFeeValue, 2);
            }
        } else {
            return 0;
        }
    },
    getDiscountAmountRounded: function getDiscountAmountRounded() {
        var digit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

        return _lodash2.default.round(this.getDiscountAmountAbs(), digit).toFixed(digit);
    },
    getCartSubTotalWithDiscountRounded: function getCartSubTotalWithDiscountRounded() {
        var digit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;


        return _lodash2.default.round(this.getCartSubTotalWithDiscountAbs(), digit).toFixed(digit);
    },
    getCouponCode: function getCouponCode() {
        return this._couponCode;
    },


    // Fixed Charge Object
    setCustomChargeFixedFee: function setCustomChargeFixedFee(fixedCharge) {

        if (fixedCharge && fixedCharge.length > 0) {

            // discounted subtotal
            var totalValue = this.getCartSubTotalWithDiscountRounded();

            var totalFixedChargesValue = 0;
            var self = this;
            var digit = 2;

            fixedCharge.map(function (charge) {

                var chargeTypeValues = charge.typeDetails.values;

                var defaultIdx = chargeTypeValues.length > 0 ? chargeTypeValues[0].idx : 0;

                var chargeFee = _CustomChargeStore2.default.getCustomChargeFeeRounded(chargeTypeValues, totalValue);

                var roundedFee = _lodash2.default.round(chargeFee, digit).toFixed(digit);

                var obj = {
                    name: charge.name,
                    desc: charge.desc,
                    fee: roundedFee,
                    type: charge.type,
                    taxable: charge.taxable,
                    idx: defaultIdx,
                    tag: charge.tag,
                    chargeId: charge.chargeId
                };

                // Check and update the custom charges in the array of applied charges
                self.checkAndUpdateCustomChargeArray(obj);

                // add the all of fixed changes fee and get total sum
                totalFixedChargesValue = parseFloat(totalFixedChargesValue) + parseFloat(chargeFee);
            });

            var roundTotal = _lodash2.default.round(totalFixedChargesValue, digit).toFixed(digit);

            this._fixedChargeValue = roundTotal;
        } else {

            this._fixedChargeValue = 0;
        }

        // this.updateRoundOffStatusValue();

        //change added by DA
        this.triggerCartChange();
    },
    checkAndUpdateCustomChargeArray: function checkAndUpdateCustomChargeArray(charge) {

        var customCharge = this._customCharge;

        var chargeObjIndex = customCharge.findIndex(function (el) {
            return el.chargeId === charge.chargeId;
        });

        // check the charge already exist or not
        if (chargeObjIndex == -1) {
            this._customCharge.push(charge);
        } else {
            customCharge[chargeObjIndex].name = charge.name;
            customCharge[chargeObjIndex].desc = charge.desc;
            customCharge[chargeObjIndex].fee = charge.fee;
            customCharge[chargeObjIndex].type = charge.type;
            customCharge[chargeObjIndex].taxable = charge.taxable;
            customCharge[chargeObjIndex].idx = charge.idx;
            customCharge[chargeObjIndex].tag = charge.tag;

            // update the optionName only when charge type O
            if (!Utils.isEmpty(charge.optionName)) {
                customCharge[chargeObjIndex].optionName = charge.optionName;
            }

            if (!Utils.isEmpty(charge.typeDetailsName)) {
                customCharge[chargeObjIndex].typeDetailsName = charge.typeDetailsName;
            }
        }
    },
    getCartTotalRoundedWithCustomCharges: function getCartTotalRoundedWithCustomCharges() {
        var digit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;


        var subTotal = _lodash2.default.round(this.getCartTotalWithoutTaxAbs(), 2);

        var discountAmount = _lodash2.default.round(this.getDiscountAmountAbs(), 2);
        var deliveryFee = _lodash2.default.round(this.getDeliveryFeeAbs(), 2);
        var tip = this.getTip();
        subTotal = subTotal - discountAmount;

        // Call the getTaxedPriceRounded for getting the tax price
        var tax = _lodash2.default.round(this.getTaxedPriceRounded(), 2);
        var serviceFee = _lodash2.default.round(this.getServiceFeeRounded(), 2);

        var totalFixedValue = _lodash2.default.round(this._fixedChargeValue, 2);

        var totalOptionalChargeValue = _lodash2.default.round(this.getTotalOptionalChargeFee(), 2);

        var totalAmount = parseFloat(subTotal) + parseFloat(tax) + parseFloat(deliveryFee) + parseFloat(serviceFee) + parseFloat(tip) + parseFloat(totalFixedValue) + parseFloat(totalOptionalChargeValue);

        return _lodash2.default.round(totalAmount, digit).toFixed(digit);
    },
    getTotalOptionalChargeFee: function getTotalOptionalChargeFee() {

        var optionalCharge = this.getDefaultOptionalCharge();

        if (optionalCharge.length > 0) {

            var totalFee = optionalCharge.reduce(function (prev, next) {
                return parseFloat(prev) + parseFloat(next.fee);
            }, 0);

            return totalFee;
        } else {
            return 0;
        }
    },
    getCartTotalRounded: function getCartTotalRounded() {
        var digit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;


        var totalRounded = this.getCartTotalRoundedWithCustomCharges();

        // Get rounded value and update Total value
        var roundOffValue = _lodash2.default.round(this._roundOffValue, 2);

        var totalAmount = parseFloat(totalRounded) + parseFloat(roundOffValue);

        return _lodash2.default.round(totalAmount, digit).toFixed(digit);
    },
    getActualItem: function getActualItem(itemId) {
        return this._actualItems[itemId];
    },
    getPaymentMethod: function getPaymentMethod() {
        return this._paymentMethod;
    },
    isPaymentCartMethod: function isPaymentCartMethod() {
        var paymentMethod = this.getPaymentMethod();
        if (paymentMethod == null || Utils.isEmptyObj(paymentMethod)) {
            return false;
        } else {
            return true;
        }
    },
    getDeliveryAddress: function getDeliveryAddress() {
        return this._deliveryAddress;
    },
    getDeliveryDistance: function getDeliveryDistance() {
        var digit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

        return _lodash2.default.round(this._deliveryDistance, digit);
    },
    getDeliveryDistanceInMeter: function getDeliveryDistanceInMeter() {
        return this._deliveryDistanceInMeter;
    },
    getOrderType: function getOrderType() {
        return this._orderType;
    },
    setDeliveryFee: function setDeliveryFee(fee) {
        this._deliveryFee = fee;
    },
    setDeliveryFeeType: function setDeliveryFeeType(feeType) {
        this._deliveryFeeType = feeType;
    },
    setDeliveryDistance: function setDeliveryDistance(deliveryDistance) {
        this._deliveryDistance = deliveryDistance;
    },
    setDeliveryDistanceInMeter: function setDeliveryDistanceInMeter(deliveryDistance) {
        this._deliveryDistanceInMeter = deliveryDistance;
    },
    setDeliveryAddress: function setDeliveryAddress(deliveryAdd) {
        this._deliveryAddress = deliveryAdd;
    },


    // Optional Charge with Custom
    updateCustomChargeObjectWithFee: function updateCustomChargeObjectWithFee(chargeObj, fee, selectedIdx, custom) {
        var optionName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;


        var self = this;
        if (!Utils.isEmptyObj(chargeObj)) {

            var obj = {
                name: chargeObj.name,
                desc: chargeObj.desc,
                fee: fee,
                type: chargeObj.type,
                taxable: chargeObj.taxable,
                idx: selectedIdx,
                tag: chargeObj.tag,
                chargeId: chargeObj.chargeId
            };

            if (!Utils.isEmpty(optionName)) {
                obj.optionName = optionName;
            }

            if (chargeObj.type == "O" || chargeObj.type == "R") {

                if (!Utils.isEmpty(chargeObj.typeDetails.name)) {
                    obj.typeDetailsName = chargeObj.typeDetails.name;
                }
            }

            // Check and update the custom charge object
            self.checkAndUpdateCustomChargeArray(obj);
        }

        // update the round off value after change the options
        this.updateRoundOffStatusValue();
    },


    // Delete the charge object from customCharge array
    deleteCustomChargeObjectWithFee: function deleteCustomChargeObjectWithFee(chargeObj) {

        var customCharge = this._customCharge;

        // find the charge based on the chargeId
        var chargeObjIndex = customCharge.findIndex(function (charge) {
            return charge.chargeId == chargeObj.chargeId;
        });

        // remove from the array
        if (chargeObjIndex != -1) {
            // remove the element
            customCharge.splice(chargeObjIndex, 1);
        }

        // update the round off value after change the options
        this.updateRoundOffStatusValue();
    },
    getCustomCharge: function getCustomCharge() {
        return this._customCharge;
    },


    // Call the function after click on the roundUp
    updateRoundOffStatus: function updateRoundOffStatus(status, chargeObj) {
        this._roundOffStatus = status;
        // Default set the fee 0 update round up fee after update all the data
        if (status == true) {
            // add round up value in the pricing table
            this.updateCustomChargeObjectWithFee(chargeObj, 0, 0, false);
        } else {
            // remove round up value from the pricing table
            this.deleteCustomChargeObjectWithFee(chargeObj);
        }
    },
    loadDefaultFixedOptionalChargeValue: function loadDefaultFixedOptionalChargeValue(orderType) {

        // Get the fixed charges
        var fixedCharge = _CustomChargeStore2.default.getCustomChargeConfig(orderType, "F");

        if (fixedCharge != null) {
            // set the fixed charge fee in cart store
            this.setCustomChargeFixedFee(fixedCharge);
        }

        // Get the optional charges
        var optionalCharge = _CustomChargeStore2.default.getCustomChargeConfig(orderType, "O");

        if (optionalCharge != null) {
            /* initialize the default selected value */
            this.updateDefaultOptionalChargeValue(optionalCharge);
        }
    },
    updateRoundOffStatusValue: function updateRoundOffStatusValue() {

        var status = this._roundOffStatus;

        if (status == true) {

            var total = this.getCartTotalRoundedWithCustomCharges();

            var roundedValue = Math.ceil(total);

            var roundoffValue = roundedValue - total;

            var digit = 2;
            this._roundOffValue = _lodash2.default.round(roundoffValue, digit).toFixed(digit);
        } else {
            this._roundOffValue = 0;
        }

        // call this function to update the cart store value
        this.updateRoundUpValue();
    },
    updateRoundUpValue: function updateRoundUpValue() {

        // get the roundOfValue
        var roundUpVal = this.getRoundOffValue();

        if (roundUpVal != null) {

            var customCharge = this._customCharge;

            // get charge based on the charge type "R" and update the fee
            var chargeIndex = customCharge.findIndex(function (el) {
                return el.type === 'R';
            });

            if (chargeIndex != -1) {
                customCharge[chargeIndex].fee = roundUpVal;
            }
        }

        this.triggerCartChange();
    },
    getRoundOffValue: function getRoundOffValue() {

        if (this._roundOffStatus) {

            var digit = 2;
            return _lodash2.default.round(this._roundOffValue, digit).toFixed(digit);
        } else {
            return null;
        }
    },
    getRoundOffStatus: function getRoundOffStatus() {
        return this._roundOffStatus ? this._roundOffStatus : false;
    },
    resetCustomChargeDataOfCart: function resetCustomChargeDataOfCart() {
        var reloadCart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        this._roundOffStatus = false;
        this._roundOffValue = 0;
        this._fixedChargeValue = 0;
        this._defaultOptionalCharge = [];
        this._defaultOptionalFlag = true;
        this._customCharge = [];

        if (reloadCart == true) {
            this.triggerCartChange();
        }
    },
    clearCartStore: function clearCartStore() {
        this._cart = [];
        this._paymentMethod = {};
        // this._orderPaymentMethodObject = {};
        this._deliveryAddress = {};
        this._orderType = this.getDefaultOrderType();
        this._actualItems = {};
        this._orderInstruction = '';
        this._couponCode = null;
        this._percentOff = null;
        this._deliveryFee = null;
        this._deliveryDistance = null;
        this._deliveryDistanceInMeter = null;
        this._deliveryFeeType = null;
        this._amountOff = null;
        this._tip = 0;
        this._tipType = null;
        this._tipPercent = null;
        // this._cartVisible = false;
        this._vMakeModel = '';
        this._serviceLocationData = '';
        this._vColor = '';
        this._isPreferCurbsideEnabled = false;
        this._isPickUpLocationSelected = false;
        this._isUtensilsAndNapkinsEnabled = '';
        this._itemTaxError = false;
        this._roundOffStatus = false;
        this._roundOffValue = 0;
        this._fixedChargeValue = 0;
        this._defaultOptionalCharge = [];
        this._defaultOptionalFlag = true;
        this._customCharge = [];
        this._guestUserObject = {
            name: "",
            email: "",
            phoneNumber: "",
            password: "",
            createGuestUserAccount: false
        };
        this.triggerCartChange();
    }
});
exports.default = CartStore;


//////////////////
// WEBPACK FOOTER
// ./src/stores/CartStore.jsx
// module id = 413
// module chunks = 0